import { render, staticRenderFns } from "./ReassessmentCard.vue?vue&type=template&id=da86b298&scoped=true"
import script from "./ReassessmentCard.vue?vue&type=script&lang=js"
export * from "./ReassessmentCard.vue?vue&type=script&lang=js"
import style0 from "./ReassessmentCard.vue?vue&type=style&index=0&id=da86b298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da86b298",
  null
  
)

export default component.exports